import {Route} from "@angular/router";
import {guardMeasuresWatch} from "@/app/routes/guards/measures-guard";

const NAME = 'Типы результата'

export const measure: Route[] = [
    {
        path: 'measures',
        loadComponent: () => import('@components/guides/measures/measures.component').then(c => c.MeasuresComponent),
        canActivate: [guardMeasuresWatch],
        data: {
            burger: NAME,
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: null},
            ],
            title: NAME,
            searchString: true
        }
    },
    {
        path: 'measures/:id',
        loadComponent: ()=>import('@components/guides/measures/measure-details/measure-details.component').then(c=>c.MeasureDetailsComponent),
        canActivate: [guardMeasuresWatch],
        data: {
            burger: NAME,
            breadcrumbs: [
                {name: 'Справочники', url: '/'},
                {name: NAME, url: '/measure/'},
            ]
        }
    },

]
